module.exports = __webpack_public_path__ + "img/accessory_hat_04.bd695e93.svg";